import React, { FC } from 'react';

const getSuggestionClass = (result: IMapLocation) => {
  const className = ' au-map__suggestion__';
  if (result.type === '0') {
    return `${className}building`;
  }
  if (result.type === '1') {
    return `${className}department`;
  }
  return '';
};

type Props = {
  result: IMapLocation | IEmployee;
}

const SuggestionComponent: FC<Props> = ({ result }) => {
  const bld = result as IMapLocation;
  if (bld.type) {
    return (
      <span className={`au-map__suggestion${getSuggestionClass(result as IMapLocation)}`}>
        {result.suggestion}
      </span>
    );
  }

  const person = result as IEmployee;
  return (
    <div className="row row--align-left au-map__person-suggestion">
      {
        person.photo !== '' && (
          <div className="row__item">
            <img src={person.photo} alt={person.fullName} />
          </div>
        )
      }
      <div className="row__item">
        <h4>
          <strong>
            {person.fullName}
          </strong>
        </h4>
        {
          (person.departments.length > 0) && (
            <p>
              {person.departments[0].name}
            </p>
          )
        }
      </div>
    </div>
  );
};

SuggestionComponent.displayName = 'SuggestionComponent';
export default SuggestionComponent;
